import './assets/main.css'
import '@/helpers/axios'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.locale('he')
dayjs.extend(duration)
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'

import PrimeVue from 'primevue/config'

import 'primeicons/primeicons.css'

import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import FocusTrap from 'primevue/focustrap'
import { he } from './he.json'

const Noir = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{zinc.50}',
      100: '{zinc.100}',
      200: '{zinc.200}',
      300: '{zinc.300}',
      400: '{zinc.400}',
      500: '{zinc.500}',
      600: '{zinc.600}',
      700: '{zinc.700}',
      800: '{zinc.800}',
      900: '{zinc.900}',
      950: '{zinc.950}'
    },
    colorScheme: {
      light: {
        primary: {
          color: '{zinc.950}',
          inverseColor: '#ffffff',
          hoverColor: '{zinc.900}',
          activeColor: '{zinc.800}'
        },
        highlight: {
          background: '{zinc.950}',
          focusBackground: '{zinc.700}',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      },
      dark: {
        primary: {
          color: '{zinc.50}',
          inverseColor: '{zinc.950}',
          hoverColor: '{zinc.100}',
          activeColor: '{zinc.200}'
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        }
      }
    }
  }
})

const app = createApp(App)

console.log('NODE_ENV', import.meta.env.MODE)

import LogRocket from 'logrocket'
import { SwalDelete } from './helpers/mySwal'

const sentryEnabledEnvs = ['production', 'staging']
if (sentryEnabledEnvs.includes(import.meta.env.MODE)) {
  LogRocket.init('kfpps0/job')
  Sentry.init({
    app,
    dsn: 'https://09db47d0aa482f27cfca92fea3a2379e@o4508919529865216.ingest.de.sentry.io/4508919530258512'
  })
}

app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: Noir,
    options: {
      darkModeSelector: '.my-app-dark'
    }
  },
  locale: he,
  pt: {
    datepicker: {
      timePicker: 'flex-row-reverse!',
      pcPrevButton: {
        root: '-order-1! rotate-180'
      },
      pcNextButton: {
        root: 'order-1! rotate-180'
      }
    },
    tag: {
      label: 'font-bold'
    },
    autocomplete: {
      overlay: 'right-0!'
    }
  }
})
app.directive('focustrap', FocusTrap)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (!reg) return

    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing
      if (!newWorker) return

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent('pwa-update-available', { detail: newWorker }))
        }
      })
    })
  })
}

app.mount('#app')
